import "./PageFooter.scss";

function PageFooter() {
  return (
    <footer className="footer">
      <p className="footer__text">© InStock Inc. All Rights Reserved.</p>
    </footer>
  );
}
export default PageFooter;
